<h1>Frequently Asked Questions</h1>
@for (faq of faqList; track faq.id){
    @if (faq.display){
        <h2>{{faq.question}}</h2>
        <div [innerHTML]="faq.answer"></div>
        <hr class="my-3">
    }
}